import { render, staticRenderFns } from "./Terms.vue?vue&type=template&id=54a8e8ce&lang=pug"
import script from "./Terms.vue?vue&type=script&setup=true&lang=ts"
export * from "./Terms.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports